import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'antd';
import { get } from 'lodash';

import i18n from 'services/i18n';
import { IS_CRITERIA, GENDER } from 'constants/options';

@i18n('form')
export default class GenderForm extends Component {
  static propTypes = {
    record: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
  };

  render() {
    const { record, translate } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Form>
        <Input.Group compact>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('isSimPatHasCriterion', {
              initialValue: record.criterion.isSimPatHasCriterion
                ? 'is'
                : 'isnt',
            })(
              <Select
                style={{ marginRight: 10 }}
                placeholder={translate('chooseOptions')}
                onClick={e => e.stopPropagation()}
              >
                {IS_CRITERIA.map(item => (
                  <Select.Option key={item.value} value={item.value}>
                    {translate(item.value)}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            {getFieldDecorator('gender', {
              initialValue: get(record, 'criterion.gender', 'MALE'),
            })(
              <Select
                placeholder={translate('chooseGender')}
                onClick={e => e.stopPropagation()}
              >
                {GENDER.map(item => (
                  <Select.Option key={item.value} value={item.value}>
                    {translate(item.value)}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </Form.Item>
        </Input.Group>
      </Form>
    );
  }
}
